// Signing an owner out of this browser: drafts of configs kept here go with the session, so when one has changes
// that aren't in the library, the owner is asked first.
import { useCallback } from 'react';
import { useAuth } from '../../auth';
import { count } from '../../lib/words';
import { useConfirm } from '../../ui';
import { unsavedDrafts } from '../create/config/drafts';

/** What signing out loses, in a sentence, or null when it loses nothing. */
export async function whatSigningOutLoses(): Promise<string | null> {
  const n = await unsavedDrafts();
  if (n === 0) {
    return null;
  }
  return `${count(n, 'config draft')} in this browser ${n === 1 ? 'has' : 'have'} changes that aren't in your library. Signing out deletes ${n === 1 ? 'it' : 'them'}.`;
}

/** Signs the owner out, after asking when it would lose a draft's changes. */
export function useSignOut(): () => Promise<void> {
  const auth = useAuth();
  const confirm = useConfirm();
  return useCallback(async () => {
    const loses = await whatSigningOutLoses();
    if (loses && !(await confirm({ title: 'Sign out?', message: loses, confirm: 'Sign out' }))) {
      return;
    }
    await auth.signOut('owners');
  }, [auth, confirm]);
}
